import React, { useState } from "react";
// import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Header } from "./Header";
import { GeneralPanel } from "./GenralPanel";
import { DashBoard } from "./Dashboard";
import { VideoContext } from "../Helper/Context";
import VideoPage from "./Video";



import { Route, Switch } from "react-router-dom";

const App = () => {
  const [video, setVideo] = useState([]);
  const [change, setChange] = useState(false);
  const [result, setResult] = useState([]);
  const userSetting = {
    video: video,
    change: change,
    result: result,
    setResult,
    setChange,
    setVideo,
  };

  return (
    <VideoContext.Provider value={userSetting}>
      <Header />
     
      <GeneralPanel />

      <Switch>
        <Route exact path="/">
          <DashBoard />
        </Route>
        <Route path="/videos/:id">
          <VideoPage />
        </Route>
        
      </Switch>
    </VideoContext.Provider>
  );
};

export default App;
